import { IconButton, IconButtonProps, Tooltip } from '@material-ui/core';
import { withStyles, WithStyles } from '@material-ui/styles';
import clsx from 'clsx';

import { styles } from './CalendarButton.styles';

import { Icon } from '~ui-kit';

export type CalendarButtonProps = IconButtonProps &
  WithStyles<typeof styles> & {
    tooltip?: string;
  };

export const CalendarButton = withStyles(styles)(
  ({ classes, tooltip = 'Monthly NHA', ...props }: CalendarButtonProps) => (
    <Tooltip title={tooltip} placement="top">
      <IconButton {...props} classes={{ root: clsx(classes.root) }}>
        <Icon icon="calendar" classes={{ root: clsx(classes.icon) }} />
      </IconButton>
    </Tooltip>
  )
);
